import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {IonButton} from '@ionic/angular/standalone';

type CtaButtonFill = 'clear' | 'outline' | 'solid' | 'default';
type CtaButtonShape = 'round' | 'default';
type CtaButtonSize = 'small' | 'default' | 'large';
type CtaButtonExpand = 'block' | 'full' | 'default';
type CtaButtonType = 'button' | 'submit' | 'reset';

@Component({
	selector: 'app-cta-button',
	standalone: true,
	templateUrl: './app-cta-button.component.html',
	styleUrls: ['./app-cta-button.component.scss'],
	imports: [IonButton, RouterLink],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppCtaButtonComponent {
	label = input<string | null>(null);
	fill = input<CtaButtonFill>('outline');
	shape = input<CtaButtonShape>('default');
	size = input<CtaButtonSize>('default');
	expand = input<CtaButtonExpand>('default');
	color = input('danger');
	disabled = input(false);
	type = input<CtaButtonType>('button');
	routerLink = input<string | null>(null);
	minWidth = input<'auto' | 'sm' | 'md' | 'lg'>('md');
	fullWidth = input(false);
}
